import React, { useState } from 'react';
import { ArrowLeft, Scroll, CheckSquare, Square } from 'lucide-react';

interface Props {
  onBack: () => void;
}

export const LegacyPlannerScreen: React.FC<Props> = ({ onBack }) => {
  const [items, setItems] = useState([
    { id: 1, text: "Draft Last Will & Testament", checked: true },
    { id: 2, text: "Designate Beneficiaries for Accounts", checked: false },
    { id: 3, text: "Create Living Trust", checked: false },
    { id: 4, text: "Assign Power of Attorney", checked: false },
    { id: 5, text: "Medical Directives", checked: false },
  ]);

  const toggle = (id: number) => {
    setItems(items.map(i => i.id === id ? { ...i, checked: !i.checked } : i));
  };

  return (
    <div className="max-w-2xl mx-auto px-4 pt-8 animate-fade-in pb-20">
      <button onClick={onBack} className="flex items-center gap-2 text-slate-400 hover:text-white mb-6 transition-colors">
        <ArrowLeft size={20} />
        Back to Dashboard
      </button>

      <div className="bg-slate-800 border border-slate-700 rounded-2xl p-6 shadow-2xl">
        <div className="flex items-center gap-4 mb-8">
          <div className="p-4 bg-emerald-900/30 rounded-xl text-emerald-400">
            <Scroll size={32} />
          </div>
          <div>
            <h1 className="text-2xl font-black text-white">Legacy Blueprint</h1>
            <p className="text-slate-400">Estate Planning Checklist</p>
          </div>
        </div>

        <div className="space-y-3">
          {items.map(item => (
            <button
              key={item.id}
              onClick={() => toggle(item.id)}
              className={`w-full text-left p-4 rounded-xl border flex items-center gap-4 transition-all ${
                item.checked 
                  ? 'bg-emerald-900/10 border-emerald-900/50 text-emerald-100' 
                  : 'bg-slate-900 border-slate-700 text-slate-300 hover:bg-slate-700'
              }`}
            >
              {item.checked ? <CheckSquare className="text-emerald-500" /> : <Square className="text-slate-500" />}
              <span className={item.checked ? 'line-through opacity-50' : ''}>{item.text}</span>
            </button>
          ))}
        </div>
        
        <div className="mt-8 p-4 bg-slate-900 rounded-lg text-xs text-slate-400 italic text-center">
          "The true meaning of life is to plant trees, under whose shade you do not expect to sit."
        </div>
      </div>
    </div>
  );
};